import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import { utility } from '../common/utility';



@Injectable({
  providedIn: 'root'
})

export class ResourceService {

  baseUrl: string;
  constructor(private http: HttpClient) {
  }
  public getNAIBrandAdvertisements(): Observable<any> {
    this.baseUrl = environment.apiBase.concat("Resource/GetAllNAIBrandAdvertisements");
      return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAllNAIBrandAdvertisements', [])));
  }
  public getNAISponsorLogos(): Observable<any> {
    this.baseUrl = environment.apiBase.concat("Resource/GetAllNAISponsorLogos");
      return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAllNAISponsorLogos', [])));
  }

  public getAllResourceCategories(): Observable<any> {
    this.baseUrl = environment.apiBase.concat("Resource/GetAllResourceCategories");
    return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetAllResourceCategories', [])));
  }

  public getResourcesByCategoryId(categoryId: any): Observable<any> {

    this.baseUrl = environment.apiBase.concat("Resource/GetResourcesByCategoryId?Id=" + categoryId);
    return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('getResourcesByCategoryId', [])));
  }

  public getResourceById(Id: any): Observable<any> {

    this.baseUrl = environment.apiBase.concat("Resource/GetResourceById?Id=" + Id);
    return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('getResourceById', [])));
  }

  public searchResources(searchterm: string): Observable<any> {

    this.baseUrl = environment.apiBase.concat("Resource/SearchResources?searchterm=" + searchterm);
    return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('searchResources', [])));
  }

  public InactivateResource(Id: any): any {
    this.baseUrl = environment.apiBase.concat("Resource/InactivateResource?NAIResourceID=" + Id);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseUrl, Id, { headers: headers }).
      pipe(catchError(utility.handleError<any>('InactivateResource', [])));
  }
  public UploadResourceLink(lnk:any): any {    

    this.baseUrl = environment.apiBase.concat("Resource/UploadResourceLink");
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseUrl, lnk, { headers: headers }).
      pipe(catchError(utility.handleError<any>('UploadResourceLink', [])));
  }

  public saveResource(res: any): any {
    this.baseUrl = environment.apiBase.concat("Resource/SaveResource");
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseUrl, res, { headers: headers }).
      pipe(catchError(utility.handleError<any>('saveResource', [])));
  }

  public InactivateResourceCategory(Id: any): any {
    this.baseUrl = environment.apiBase.concat("Resource/InactivateResourceCategory?CategoryId=" + Id);
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseUrl, Id, { headers: headers }).
      pipe(catchError(utility.handleError<any>('InactivateResourceCategory', [])));      
  }

  public AddResourceCategory(res: any): any {
    this.baseUrl = environment.apiBase.concat("Resource/AddResourceCategory");
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(this.baseUrl, res, { headers: headers }).
      pipe(catchError(utility.handleError<any>('AddResourceCategory', [])));
    }

    public GetPolicyUrlByDocTypeId(id) {
        this.baseUrl = environment.apiBase.concat("Resource/GetPolicyUrlByDocTypeId?PolicyDocumentType=" + id);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetPolicyUrlByDocTypeId', [])));
    }

    public GetPolicyUpdateDate(typeId) {
        this.baseUrl = environment.apiBase.concat("Resource/GetPolicyUpdateDate?typeId=" + typeId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetPolicyUpdateDate', [])));
    }

    public GetUserAgreements(userId) {
        this.baseUrl = environment.apiBase.concat("Resource/GetUserAgreements?userId=" + userId);
        return this.http.get<any[]>(this.baseUrl).pipe(catchError(utility.handleError<any[]>('GetUserAgreements', [])));
    }

    public NotifyUserAgreement(userAgreement): any {
        this.baseUrl = environment.apiBase.concat("Resource/NotifyUserAgreement");
        let headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http.post(this.baseUrl, userAgreement, { headers: headers }).
            pipe(catchError(utility.handleError<any>('NotifyUserAgreement', [])));
    }
}
